<template>
	<div
		class="featured_icon_tile"
		:style="{'--size': size}"
		:class="{'full-width': size === 'span 12', 'two-thirds': size === 'span 8', 'one-third': size === 'span 4'}"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
	>
		<div class="inner">
			<div class="content">
				<h4 v-html="title"></h4>
				<img
					:src="parsedIcon.url"
					:alt="parsedIcon.alt"
				/>
				<div
					class='description'
					v-html="description"
				></div>
			</div>
			<div
				class='cta_container'
				v-if="parsedCta"
			>
				<primary-button
					:link="parsedCta"
					:label="parsedCta.title"
					:is_hovered="hovered"
				></primary-button>
			</div>
		</div>
	</div>
</template>

<script>
import PrimaryButton from './PrimaryButton.vue';
export default {
	data() {
		return {
			hovered: false,
		};
	},

	props: {
		title: {},
		icon: {},
		description: {},
		call_to_action: {},
		size: {},
	},

	computed: {
		parsedCta() {
			if (this.call_to_action) {
				return JSON.parse(this.call_to_action);
			} else {
				return null;
			}
		},

		parsedIcon() {
			if (this.icon) {
				return JSON.parse(this.icon);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: { PrimaryButton },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.featured_icon_tile {
	display: grid;
	background: var(--very-light-grey);
	grid-column: var(--size);
	/* border: 2px solid transparent; */
	transition: 0.2s ease all;

	.inner {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	&.index__zero {
		padding: 50px 50px 50px 40px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.index__one {
		padding: 50px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.index__two {
		padding: 50px 40px 50px 50px;

		@media (max-width: $mobile-xl) {
			padding: 24px;
		}
	}

	&.two-thirds {
		grid-template-columns: 100px auto 100px;

		@media (max-width: $laptop) {
			grid-template-columns: unset;
		}

		.inner {
			grid-column: 2 / span 1;

			@media (max-width: $laptop) {
				grid-column: unset;
			}
		}
	}

	h4 {
		color: var(--grey);
	}

	img {
		width: 30px;
		margin-top: 50px;
	}

	.description {
		margin-top: 30px;

		&::v-deep {
			p {
				&:first-of-type {
					margin-top: 0;
				}

				&:last-of-type {
					margin-bottom: 0;
				}
			}
		}
	}

	.cta_container {
		margin-top: 50px;
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/FeaturedIconTile.vue